import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { ListingPage } from '../../model';
import type { Injection } from '../model';

export const selectInjectionState = (
  state: SpartacuxProductDiscoveryDomainState,
  pageName?: ListingPage | null,
): Injection | undefined =>
  pageName !== undefined && pageName !== null
    ? state.productDiscovery?.listingInjection?.stateByPage?.[pageName]
    : undefined;
